import{isNumber}from"../../utils/type-guards";export var timeForMap={0:"start",1:"end"};export var getTimeFof=function(a){if(isNumber(a))return timeForMap[a]};
//# sourceMappingURL=timeForMap.js.map